import * as React from 'react';
import { Box } from '../../components/Box';
import { Guide } from '../../guide';
import { Text } from '../../components/forms';
import { guideURL } from '../../utils/config';

type Props = {
  guide: Guide;
};

export default function GuideShareSection(props: Props) {
  return (
    <div className="mw6 ml-auto mr-auto pt5">
      <Text
        label="Shareable URL"
        field=""
        id=""
        name=""
        defaultValue={guideURL(props.guide.public_url)}
        onValueChange={() => {}}
      />
    </div>
  );
}
